import React from 'react';
import RegistrationForm from '../RegistrationForm';
import { CheckCircle } from 'lucide-react';
import SEO from './SEO';

export default function PageRegistracia() {
    return (
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-20 min-h-screen">
            <SEO 
                title="Online Registrácia | Malodunajský vodácky maratón"
                description="Zaregistrujte sa online na Malodunajský vodácky maratón. Jednoduchý formulár pre jednotlivcov aj posádky."
                keywords="registrácia maratón, prihláška splav, štartovné"
            />
            <div className="flex flex-col items-center mb-16 text-center">
                <div className="p-4 bg-yellow-400 rounded-3xl shadow-2xl shadow-yellow-400/20 mb-6">
                    <CheckCircle className="w-10 h-10 md:w-12 md:h-12 text-blue-900" />
                </div>
                <h1 className="text-3xl md:text-5xl font-black uppercase tracking-widest text-white drop-shadow-md mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    Registrácia
                </h1>
                <p className="text-white/60 font-medium text-lg max-w-xl">
                    Pridajte sa k stovkám vodákov na najväčšom maratóne na Malom Dunaji. Vyberte kategóriu a pripravte svoju posádku!
                </p>
                <div className="w-24 h-1.5 bg-yellow-400 mt-8 rounded-full shadow-[0_0_15px_rgba(250,204,21,0.5)]"></div>
            </div>

            <RegistrationForm />
        </div>
    );
}
